export default function Footer() {
  return (
    <footer id="footer" className="bg-primary-900 text-background-200 pt-14 md:pt-20 pb-8">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 font-heading whitespace-nowrap">番茄视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              番茄视频汇聚香蕉视频、红桃视频、蜜桃视频、91视频等海量高清影视资源，提供电影、电视剧、综艺全集免费在线观看。1080P高清画质，流畅不缓冲，满足您的追剧需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="space-y-2.5">
              {[
                { label: '精选推荐', href: '#media' },
                { label: '热播榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '影视索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a key={link.href} href={link.href} className="block text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{link.label}</a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容频道</h3>
            <div className="space-y-2.5">
              {['香蕉视频', '红桃视频', '蜜桃视频', '91视频'].map((name) => (
                <a key={name} href="#media" className="block text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">{name}</a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              番茄视频与多家优质影视内容提供商保持紧密合作，持续为用户带来更多高清影视资源。合作洽谈请联系客服。
            </p>
          </div>
        </div>

        <div className="border-t border-primary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 番茄视频 - 高清电影电视剧免费在线观看平台。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#faq" className="hover:text-background-300 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
            <a href="#about" className="hover:text-background-300 transition-colors cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}